<template>
  <div>
    <img
      class="titleimg"
      src="/static/imgs/shouye6.png"
      style="width: 100%; height: 150px ;object-fit: cover;"
    />
    <el-row :span="24">
      <el-col class="title" :span="16" :offset="4" :xs="{span:24,offset:1}"
        ><img src="/static/imgs/jishuzhichi.png" alt=""
      /></el-col>
      <el-col :span="16" :offset="4">
        <el-col :span="6" :xs="{ span: 24 }" class="item_list">
          <i class="iconfont icon-chanpin"></i>
          <p>产品服务</p>
          <span
            >解决产品日常使用问题，最终为客户提供高效、稳定的网络安全环境和硬件产品保障</span
          >
        </el-col>
        <el-col :span="6" :xs="{ span: 24 }" class="item_list">
          <i class="iconfont icon-xitong"></i>
          <p>系统服务</p>
          <span
            >网络结构改造、设备扩容、补丁修复、版本升级等原因，信息系统变更导致的现场服务需求</span
          >
        </el-col>
        <el-col :span="6" :xs="{ span: 24 }" class="item_list">
          <i class="iconfont icon-jishufuwu"></i>
          <p>技术资料</p>
          <span
            >面向客户基于网络事件及安全事件的快速响应及现场技术支持服务</span
          >
        </el-col>
        <el-col :span="6" :xs="{ span: 24 }" class="item_list">
          <i class="iconfont icon-caozuo-yuedu"></i>
          <p>操作说明</p>
          <span
            >现运行网络和软、硬件设备、应急故障、日常监控，提供技术保障和系统运行维护服务</span
          >
        </el-col>
      </el-col>
    </el-row>
    <el-row class="bottom" :span="24">
      <el-col :span="16" :offset="4" :xs="{span:24,offset:0}" class="serve">服务理念</el-col>
      <el-col :span="16" :offset="4" :xs="{span:24,offset:0}" class="serve_info"
        >有效帮助客户及时预判并处理网络中的问题，解决产品日常使用问题，最终为客户提供高效、稳定的网络安全环境和硬件产品保障。</el-col
      >
      <el-col :span="16" :offset="4" class="phone" :xs="{span:24,offset:0}"
        >联系电话：0311-87243465 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;手机：13722868077</el-col
      >
      <el-col :span="24"  class="icon">
      <el-col :span="3"><i class="iconfont icon-baoxiu"></i><p>故障报修</p></el-col>
      <el-col :span="3"><i class="iconfont icon-lianxiren"></i><p>联系支持</p></el-col>
      <el-col :span="3"><i class="iconfont icon-liuyanjianyi"></i><p>建议反馈</p></el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
@media screen and (max-width: 700px) {
  .titleimg {
    height: auto !important;
  }
  .bottom {
    padding: 0 40px;
  }
}
.icon{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;
  margin-bottom:80px;
  i{
    font-size: 40px;
    color: #1555D0;
  }
}
.bottom {
  margin-top: 80px;
  overflow: hidden;
  // flex-wrap: wrap;
  // justify-content: center;
  text-align: center;
  .serve {
    color: #313131;
    font-size: 32px;
    font-weight: 700;
    font-family: "Microsoft YaHei";
  }
  .serve_info {
    color: #727272;
    font-size: 20px;
    font-weight: 400;
    font-family: "Microsoft YaHei";
    margin-top:24px;
    margin-bottom:24px;
  }
  .phone{
    color: #1555d0;
 font-size: 20px;
 font-weight: 700;
 font-family: "Microsoft YaHei";
  }
}
.title {
  height: 64px;
  margin-top: 40px;
  margin-bottom: 40px;
}
.item_list {
  // cursor: pointer;
  padding: 40px 40px;
  text-align: center;
  height: 350px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  i {
    font-size: 50px;
    // width: 108px;
    // height:108px;
    // display: block;
    text-align: center;

    flex-basis: 100%;
  }
  p {
    text-align: center;
    color: #454545;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 32px;
  }
  span {
    text-indent: 2em;
    text-align: justify;
    display: block;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    font-family: "Microsoft YaHei";
  }
}
.item_list:hover {
  background-color: #1555d0;
  p {
    color: #fff;
  }
  span {
    color: #fff;
  }
  i {
    color: #fff;
  }
}
</style>
